import { Link, Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import SignupForm from '../../features/auth/SignupForm'

function SignupPage() {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="login-page auth-page">
      <div className="auth-shell">
        <aside className="auth-brand-panel">
          <Link to="/" className="logo">
            <div className="logo-icon">SSV</div>
            <span>Second Shift Ventures</span>
          </Link>
          <div>
            <span className="auth-eyebrow">Internal workspace</span>
            <h1>Useful products need useful operations.</h1>
            <p>
              Create an internal account for the Second Shift workspace and keep
              product, finance, and team work in one place.
            </p>
          </div>
          <div className="auth-proof-row">
            <span>Products</span>
            <span>Finance</span>
            <span>Ops</span>
          </div>
        </aside>

        <div className="login-card auth-card animate-fade-in">
          <div className="login-header">
            <Link to="/" className="logo auth-card-logo">
              <div className="logo-icon">SSV</div>
              <span>Second Shift</span>
            </Link>
            <h1>Create an account</h1>
            <p>Join the internal studio workspace</p>
          </div>

          <SignupForm />
        </div>
      </div>
    </div>
  )
}

export default SignupPage
